import React from "react";

import "../Results.css";
import TicketHeader from "../../TicketHeader";
import ResultsErrorsButtons from "./ResultsErrorsButtons";
import ResultsAnswers from "../ResultsAnswers";

const ResultsError = (props) => {
  const categoryTickets = props.categoryTickets;
  const reducer = (accumulator, currentValue) => {
    if (currentValue.isError) accumulator++;
    return accumulator;
  };
  const counterWrongAnswers = props.finalResultArray.reduce(reducer, 0);
  let errorsArray = JSON.parse(localStorage.getItem("errorsArray"));

  const currentErrorsArrayItem = errorsArray.find(
    (errorItem) =>
      parseInt(props.currentTicket.ticketId) === errorItem.ticketId &&
      categoryTickets.slice(
        categoryTickets.length - 2,
        categoryTickets.length
      ) ===
        errorItem.ticketCategory.slice(
          errorItem.ticketCategory.length - 2,
          errorItem.ticketCategory.length
        )
  );

  const index = errorsArray.indexOf(currentErrorsArrayItem);
  const allErrors = props.currentTicket.tasks.length;
  const errorsSolved = allErrors - counterWrongAnswers;

  return (
    <div>
      <div className="shared-card mobile-results">
        <TicketHeader
          notToRenderTimer={true}
          currentTicketHeader={props.currentTicketHeader}
        />

        <div className="results-info">
          <div>
            <p className="result-counter">
              {errorsSolved + " "}из{" " + allErrors}
            </p>
            <p className="result-label">Ошибок проработано</p>
          </div>
        </div>
        <ResultsErrorsButtons
          categoryTickets={categoryTickets}
          counterWrongAnswers={counterWrongAnswers}
          ticketsArray={props.ticketsArray}
          allErrorsCounter={allErrors}
          errorsSolved={errorsSolved}
          firstIdOfCurrentTicketTask={
            errorsArray[index].ticketErrors.sort((a, b) => a - b)[0]
          }
        />
      </div>
      <ResultsAnswers
        categoryTickets={props.categoryTickets}
        currentTicket={props.currentTicket}
        finalResultArray={props.finalResultArray}
      />
    </div>
  );
};

export default ResultsError;
